class Constants {
    public static readonly APP_NAME = "Widget Media Labs";
    public static readonly APP_VERSION = "1.0.0";
    public static readonly playstoreLink = "https://play.google.com/store/apps/developer?id=Widget+Media+Labs";
}

export default Constants;